import type { IFulfillmentGroup } from "@/data/model/FulfillmentGroup";
import type { IOperatorFulfillment } from "@/data/model/Operator";
import type { ShowRoomPlanEventData } from "@/data/model/Table";
import { Signal, TypedSignal } from "@/data/util/Signal";

export type ShowOrderAndPayViewEventData = { tableId: string; billId?: string };
export type OpenBillTableSelectedEventData = { tableId: string; billId: string };
export type FulfillmentClickedEventData = {
    fulfillment: IOperatorFulfillment;
    fulfillmentGroup: IFulfillmentGroup | undefined;
};

export const operatorEvents = {
    hideVisibleController: new Signal(),
    hideVisibleVueView: new Signal(),
    showOrderAndPayView: new TypedSignal<ShowOrderAndPayViewEventData>(),

    context: {
        signingOut: new Signal(),
        settingsUpdated: new Signal(),
    },
    payContext: {
        invalidSelectionsPopupViewed: new Signal(),
        goBackToPreorderTimeSelectionRequested: new Signal(),
    },
    productionContext: {
        FulfillmentsLoaded: new Signal(),
        FulfillmentAdded: new TypedSignal<IOperatorFulfillment>(),
        FulfillmentChanged: new TypedSignal<IOperatorFulfillment>(),
        LinkedFulfillmentsChanged: new TypedSignal<IOperatorFulfillment[]>(),
        FulfillmentRemoved: new TypedSignal<IOperatorFulfillment>(),
    },
    views: {
        ShowProduction: new Signal(),
        ShowRoomPlan: new TypedSignal<ShowRoomPlanEventData>(),
        ShowSettings: new Signal(),
        ShowReports: new Signal(),
        ShowItems: new Signal(),
        ShowOpenBills: new Signal(),
        ShowOrders: new Signal(),
        ShowPayments: new Signal(),
    },
    openBillsController: {
        onShown: new Signal(),
        onHidden: new Signal(),
    },
    productionController: {
        onInit: new Signal(),
        onShown: new Signal(),
        onHidden: new Signal(),
        onFulfillmentClick: new TypedSignal<FulfillmentClickedEventData>(),
    },
    roomPlanController: {
        onShown: new TypedSignal<ShowRoomPlanEventData | undefined>(),
        onHidden: new Signal(),
    },
    fulfillmentDetailsPopup: {
        orderNumberSelected: new TypedSignal<string>(),
    },
    orderDetailsModal: {
        openBillTableSelected: new TypedSignal<OpenBillTableSelectedEventData>(),
    },
    transactionDetailsWindow: {
        openBillTableSelected: new TypedSignal<OpenBillTableSelectedEventData>(),
    },
    modals: {
        closeAllModals: new Signal(),
    },
};
